var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChallenge = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.743 3.348v1.56l-5.965 6.218a1 1 0 0 0 1.444 1.384l.758-.79a2 2 0 1 1-3.523-.992 1 1 0 0 1 .108-.133l2.38-2.483a4 4 0 1 0 2.58 1.996l1.431-1.49a6 6 0 1 1-3.025-2.3l1.49-1.552a8 8 0 1 0 2.943 2.385l.754-.787h1.64a.4.4 0 0 0 .284-.117L23.3 3.988a.4.4 0 0 0-.327-.68l-2.048.228-.026.025a.997.997 0 0 0-.328-.382l.228-2.046a.4.4 0 0 0-.68-.327l-2.26 2.259a.4.4 0 0 0-.116.283Z",
  fill: "currentColor"
})));
export default SvgChallenge;